<template>
  <div style="margin-top: 25px; margin-bottom: 100px">
    <v-dialog v-model="user_dialog" width="500" persistent>
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="250"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold">{{
            action == "edit" ? "Edit Customer" : "Create Customer"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="grey" dark @click="cancel_user_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="ma-5 overflow-y-auto"
          style="text-align: left; max-height: 450px"
        >
          <v-form ref="form">
            <div>
              <p style="font-weight: bold">Company Name:</p>
              <div style="margin-top: -10px">
                <v-autocomplete
                  style="margin-bottom: 15px"
                  v-model="selected_company_name"
                  :items="company_name_list"
                  placeholder="Leave Empty if is NuVending Machine"
                  single-line
                  hide-details="auto"
                  outlined
                  single
                  dense
                  :readonly="current_user_company_doc_id != ''"
                  @change="company_selection_changed"
                ></v-autocomplete>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">App Permissions:</p>
              <div style="margin-top: -10px">
                <v-combobox
                  v-model="customer_app_permissions"
                  :items="app_permission_list"
                  single-line
                  outlined
                  multiple
                  dense
                  :readonly="!isEditor"
                  :rules="[
                    () =>
                      customer_app_permissions.length > 0 ||
                      'At least one permission must be selected',
                  ]"
                ></v-combobox>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Username:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_username"
                  single-line
                  outlined
                  dense
                  :readonly="!isEditor"
                  @input="clear_error_message('username')"
                  :error-messages="username_error_message"
                  :rules="[
                    () => !!selected_username || 'Username is required',
                    () =>
                      selected_username.length >= 5 || 'At least 5 characters',
                    () =>
                      !selected_username.includes(' ') ||
                      'No whitespace is allowed',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Email Address:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_email"
                  single-line
                  outlined
                  dense
                  @input="clear_error_message('email')"
                  :error-messages="email_error_message"
                  :readonly="!isEditor"
                  :rules="[
                    () => !!selected_email || 'Email is required',
                    () =>
                      validate_email(selected_email) || 'E-mail must be valid',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Country Code:</p>
              <div style="margin-top: -10px">
                <v-autocomplete
                  v-model="selected_country_code"
                  :items="country_code_list"
                  single-line
                  outlined
                  dense
                  @input="clear_error_message('phone_number')"
                  :error-messages="phone_number_error_message"
                  :readonly="!isEditor"
                  :rules="[
                    () => !!selected_country_code || 'Country code is required',
                  ]"
                ></v-autocomplete>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Phone Number:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="selected_phone_number"
                  single-line
                  outlined
                  dense
                  hint="e.g. 163322123"
                  :readonly="!isEditor"
                  @input="clear_error_message('phone_number')"
                  :error-messages="phone_number_error_message"
                  :rules="[
                    () => !!selected_phone_number || 'This field is required',
                    () =>
                      selected_phone_number.length >= 9 ||
                      'Invalid phone number',
                    () =>
                      /^\d+$/.test(selected_phone_number) ||
                      'Invalid phone number',
                    () =>
                      !/\s/g.test(selected_phone_number) ||
                      'Phone number can\'t contain white space',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">New Password:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="password"
                  type="password"
                  single-line
                  outlined
                  :readonly="!isEditor"
                  dense
                  :rules="[
                    () =>
                      validate_password_length(password) ||
                      'At least 9 characters',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Confirm Password:</p>
              <div style="margin-top: -10px">
                <v-text-field
                  v-model="confirm_password"
                  type="password"
                  single-line
                  :readonly="!isEditor"
                  outlined
                  dense
                  :rules="[
                    () =>
                      validate_password_length(password) ||
                      'At least 9 characters',
                    () =>
                      confirm_password == password || 'Password does not match',
                  ]"
                ></v-text-field>
              </div>
            </div>
            <div>
              <p style="font-weight: bold">Machine List:</p>
              <div style="text-align: center" v-if="machine_loading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div style="margin-top: -10px" v-else>
                <v-combobox
                  v-model="selected_machines"
                  :items="available_machine_list"
                  single-line
                  outlined
                  multiple
                  dense
                  :readonly="!isEditor"
                ></v-combobox>
              </div>
            </div>
          </v-form>
        </div>
        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            color="primary"
            class="white--text"
            block
            depressed
            style="text-transform: capitalize"
            @click="update_user"
            :loading="is_submitting"
            :disabled="is_submitting"
            v-if="isEditor"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="user_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          @click:row="view_customer"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Customers"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="isEditor">
                <v-btn
                  depressed
                  color="primary"
                  dark
                  style="text-transform: capitalize"
                  @click="open_user_dialog"
                >
                  <v-icon left dark> mdi-account-plus </v-icon>
                  Create Customer
                </v-btn>
              </div>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        { text: "Username", value: "username", sortable: true, divider: true },
        { text: "Phone Number", value: "full_phone_number", divider: true },
        {
          text: "Email Address",
          value: "email_address",
          sortable: true,
          divider: true,
        },
        {
          text: "Number of Machine",
          value: "number_of_machine",
          sortable: true,
          divider: true,
        },
      ],
      user_list: [],
      table_loading: false,
      machine_loading: false,
      search: "",
      action: "",
      username_error_message: "",
      email_error_message: "",
      phone_number_error_message: "",
      selected_user_id: "",
      selected_username: "",
      original_username: "",
      selected_email: "",
      original_email: "",
      selected_country_code: "",
      selected_phone_number: "",
      original_full_phone_number: "",
      selected_machines: [],
      password: "",
      confirm_password: "",
      user_dialog: false,
      is_submitting: false,
      country_code_list: ["Malaysia +60"],
      available_machine_list: [],
      available_detail_machine_list: [],
      available_detail_role_list: [],
      selected_company_doc_id: "",
      selected_company_name: "",
      company_name_list: [],

      current_user_permission: [],
      current_user_company_doc_id: "",
      isEditor: false,

      app_permission_list: [],
      actual_app_permission_list: [],
      customer_app_permissions: [],
    };
  },
  methods: {
    validate_password_length(password) {
      if (this.action == "create") {
        if (password == null || password == "" || password.length < 9) {
          return false;
        } else {
          return true;
        }
      } else {
        if (password == null || password == "") {
          return true;
        } else {
          if (password.length >= 9) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    validate_email(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    async load_company_options() {
      var response = await this.send_http_request(
        "getAllCompaniesWithCompanyID",
        {
          company_doc_id: this.current_user_company_doc_id,
        }
      );
      this.company_details_list = response.data.result;
      this.company_name_list = ["Nu Vending"];
      this.company_details_list.forEach((option) => {
        this.company_name_list.push(option.company_name);
      });
    },
    async create_user() {
      this.is_submitting = true;
      var result = await this.validate_duplication([
        "username",
        "email",
        "phone_number",
      ]);
      if (result) {
        var app_permissions = [];
        this.customer_app_permissions.forEach((app_permission) => {
          var index = this.actual_app_permission_list.findIndex(
            (x) => x.permission_name == app_permission
          );
          if (index > -1) {
            app_permissions.push(
              this.actual_app_permission_list[index].permission_doc_id
            );
          }
        });
        // create user
        var response = await this.send_http_request("signUpWithEmail", {
          app_permissions: app_permissions,
          username: this.selected_username,
          email_address: this.selected_email,
          country_code: this.selected_country_code.split(" ")[1],
          phone_number: this.selected_phone_number,
          password: this.password,
          company_doc_id:
            this.current_user_company_doc_id == ""
              ? this.selected_company_doc_id
              : this.current_user_company_doc_id,
        });
        if (response.data.status == "OK") {
          var user_id = response.data.user_id;
          if (this.selected_machines.length > 0) {
            var machine_doc_id_list = [];
            this.selected_machines.forEach((selected_machine_id) => {
              var index = this.available_detail_machine_list.findIndex(
                (x) => x.machine_id == selected_machine_id
              );
              if (index > -1) {
                machine_doc_id_list.push(
                  this.available_detail_machine_list[index].id
                );
              }
            });
            var response = await this.send_http_request("addMachinesToUser", {
              user_id: user_id,
              machine_list: machine_doc_id_list,
            });
            this.is_submitting = false;
            if (response.data.status == "OK") {
              this.cancel_user_dialog();
              await this.load_customer();
              this.show_snack_bar("success", "User Created");
            } else {
              this.is_submitting = false;
              this.show_snack_bar("error", "Something went wrong");
            }
          } else {
            this.is_submitting = false;
            this.cancel_user_dialog();
            await this.load_customer();
            this.show_snack_bar("success", "User Created");
          }
        } else {
          this.is_submitting = false;
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    async edit_user() {
      this.is_submitting = true;
      var validation_list = [];
      if (this.selected_username != this.original_username) {
        validation_list.push("username");
      }
      if (this.selected_email != this.original_email) {
        validation_list.push("email");
      }
      if (
        this.original_full_phone_number !=
        `${this.selected_country_code.split("+")[1]}${
          this.selected_phone_number
        }`
      ) {
        validation_list.push("phone_number");
      }
      var result = await this.validate_duplication(validation_list);
      if (result) {
        var app_permissions = [];
        this.customer_app_permissions.forEach((app_permission) => {
          var index = this.actual_app_permission_list.findIndex(
            (x) => x.permission_name == app_permission
          );
          if (index > -1) {
            app_permissions.push(
              this.actual_app_permission_list[index].permission_doc_id
            );
          }
        });
        // edit user
        var response = await this.send_http_request("updateUser", {
          app_permissions: app_permissions,
          user_id: this.selected_user_id,
          username: this.selected_username,
          email_address: this.selected_email,
          country_code: this.selected_country_code.split(" ")[1],
          phone_number: this.selected_phone_number,
          password: this.password == null ? "" : this.password,
          company_doc_id:
            this.current_user_company_doc_id == ""
              ? this.selected_company_doc_id
              : this.current_user_company_doc_id,
        });
        if (response.data.status == "OK") {
          var machine_doc_id_list = [];
          this.selected_machines.forEach((selected_machine_id) => {
            var index = this.available_detail_machine_list.findIndex(
              (x) => x.machine_id == selected_machine_id
            );
            if (index > -1) {
              machine_doc_id_list.push(
                this.available_detail_machine_list[index].id
              );
            }
          });
          var response = await this.send_http_request("addMachinesToUser", {
            user_id: this.selected_user_id,
            machine_list: machine_doc_id_list,
          });
          this.is_submitting = false;
          if (response.data.status == "OK") {
            this.cancel_user_dialog();
            await this.load_customer();
            this.show_snack_bar("success", "User Updated");
          } else {
            this.is_submitting = false;
            this.show_snack_bar("error", "Something went wrong");
          }
          // if (this.selected_machines.length > 0) {

          // } else {
          //   this.is_submitting = false;
          //   this.cancel_user_dialog();
          //   this.load_customer();
          //   this.show_snack_bar("success", "User Updated");
          // }
        } else {
          this.is_submitting = false;
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    update_user() {
      if (
        this.selected_company_name != "" &&
        this.selected_company_name != "Nu Vending"
      ) {
        this.selected_company_doc_id = this.company_details_list.find(
          (o) => o.company_name === this.selected_company_name
        ).company_doc_id;
      } else {
        this.selected_company_doc_id = "";
      }
      if (this.$refs.form.validate()) {
        if (this.action == "create") {
          this.create_user();
        } else {
          this.edit_user();
        }
      }
    },
    clear_error_message(type) {
      if (type == "username") {
        this.username_error_message = "";
      } else if (type == "email") {
        this.email_error_message = "";
      } else if (type == "phone_number") {
        this.phone_number_error_message = "";
      }
    },
    cancel_user_dialog() {
      this.selected_company_name = "";
      this.customer_app_permissions = [];
      this.selected_user_id = "";
      this.selected_username = "";
      this.original_username = "";
      this.selected_email = "";
      this.original_email = "";
      this.selected_country_code = "";
      this.selected_phone_number = "";
      this.original_full_phone_number = "";
      this.password = "";
      this.confirm_password = "";
      this.selected_machines = [];
      this.user_dialog = false;
      this.machine_loading = false;
      // this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    async load_customer() {
      this.table_loading = true;
      this.send_http_request("getAllUsersWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.user_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });

      this.send_http_request("getAllMachineIdWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          if (response.data.status == "OK") {
            response.data.result.forEach((item) => {
              this.available_machine_list.push(item.machine_id || "");
            });
            this.available_detail_machine_list = response.data.result;
            // console.log(
            //   "this.available_detail_machine_list",
            //   this.available_detail_machine_list
            // );
          } else {
            console.log("error");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    view_customer(value) {
      this.action = "edit";
      let selected_company_id =
        value.company_doc_id != null ? value.company_doc_id : "";
      if (selected_company_id != "") {
        this.selected_company_name = this.company_details_list.find(
          (o) => o.company_doc_id === selected_company_id
        ).company_name;
      } else {
        this.selected_company_name = "";
      }
      this.selected_user_id = value.user_id;
      this.selected_username = value.username;
      this.original_username = value.username;
      this.selected_email = value.email_address;
      this.original_email = value.email_address;
      this.selected_phone_number =
        value.phone_number != null ? value.phone_number : "";
      var country_code_index = this.country_code_list.findIndex((x) =>
        x.includes(value.country_code)
      );
      if (country_code_index > -1) {
        this.selected_country_code = this.country_code_list[country_code_index];
      }
      this.original_full_phone_number = value.full_phone_number;
      this.user_dialog = true;
      this.machine_loading = true;
      this.load_machine(value.user_id);

      this.app_permission_list = [];

      this.actual_app_permission_list.forEach((app_permission) => {
        if (selected_company_id == "") {
          this.app_permission_list.push(app_permission.permission_name);
        } else {
          if (app_permission.company_list.includes(selected_company_id)) {
            this.app_permission_list.push(app_permission.permission_name);
          }
        }
      });

      this.customer_app_permissions = [];
      if (value.app_permissions != null) {
        value.app_permissions.forEach((permission_doc_id) => {
          var index = this.actual_app_permission_list.findIndex(
            (x) => x.permission_doc_id == permission_doc_id
          );
          if (index > -1) {
            this.customer_app_permissions.push(
              this.actual_app_permission_list[index].permission_name
            );
          }
        });
      }
    },
    company_selection_changed(value) {
      this.customer_app_permissions = [];
      this.app_permission_list = [];

      var selected_company_id = "";

      if (value != "Nu Vending" && value != "" && value != null) {
        var index = this.company_details_list.findIndex(
          (x) => x.company_name == value
        );
        if (index > -1) {
          selected_company_id = this.company_details_list[index].company_doc_id;
        }
      }

      this.actual_app_permission_list.forEach((app_permission) => {
        if (selected_company_id == "") {
          this.app_permission_list.push(app_permission.permission_name);
        } else {
          if (app_permission.company_list.includes(selected_company_id)) {
            this.app_permission_list.push(app_permission.permission_name);
          }
        }
      });
    },
    open_user_dialog() {
      this.action = "create";
      this.selected_company_doc_id = this.current_user_company_doc_id;
      if (this.current_user_company_doc_id != "") {
        this.selected_company_name = this.company_details_list.find(
          (o) => o.company_doc_id === this.selected_company_doc_id
        ).company_name;
      }
      this.user_dialog = true;
    },
    load_machine(user_id) {
      this.machine_loading = true;
      this.send_http_request("getMachineFromUser", { user_id: user_id })
        .then((response) => {
          this.machine_loading = false;
          if (response.data.status == "OK") {
            this.selected_machines = response.data.result;
          } else {
            console.log("error");
          }
        })
        .catch((error) => {
          this.machine_loading = false;
          console.log(error);
        });
    },
    validate_duplication(required_validation_list) {
      return new Promise((res, rej) => {
        var promises = [];

        if (required_validation_list.includes("username")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsUsernameTaken", {
                username: this.selected_username,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.username_error_message = "Username has been taken";
                  } else {
                    this.username_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        if (required_validation_list.includes("email")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsEmailTaken", {
                email: this.selected_email,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.email_error_message = "Email has been taken";
                  } else {
                    this.email_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }

        if (required_validation_list.includes("phone_number")) {
          promises.push(
            new Promise((resolve, reject) => {
              this.send_http_request("checkIsPhoneTaken", {
                phone_number: `${this.selected_country_code.split("+")[1]}${
                  this.selected_phone_number
                }`,
              })
                .then((response) => {
                  if (response.data.status != "OK") {
                    this.phone_number_error_message =
                      "Phone number has been taken";
                  } else {
                    this.phone_number_error_message = "";
                  }
                  resolve("success");
                })
                .catch((error) => {
                  reject(error);
                });
            })
          );
        }
        Promise.all(promises)
          .then(() => {
            res(
              this.username_error_message == "" &&
                this.email_error_message == "" &&
                this.phone_number_error_message == ""
            );
          })
          .catch((error) => {
            rej(error);
          });
      });
    },
    async load_app_permission() {
      const response = (await this.send_http_request("getAllAppPermission", {}))
        .data;
      if (response.status == "OK") {
        response.result.forEach((item) => {
          this.actual_app_permission_list.push(item);
        });
        if (this.current_user_company_doc_id != "") {
          var selected_company_id = this.company_details_list.find(
            (o) => o.company_doc_id === this.current_user_company_doc_id
          ).company_id;
        }
        this.app_permission_list = [];

        this.actual_app_permission_list.forEach((app_permission) => {
          if (selected_company_id == null) {
            this.app_permission_list.push(app_permission.permission_name);
          } else {
            if (
              app_permission.company_list.includes(
                this.current_user_company_doc_id
              )
            ) {
              this.app_permission_list.push(app_permission.permission_name);
            }
          }
        });
      }
    },
  },
  async mounted() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    await this.load_customer();
    await this.load_company_options();
    this.load_app_permission();
    this.isEditor =
      this.current_user_company_doc_id == "" ||
      (this.current_user_company_doc_id != "" &&
        (this.current_user_permission.includes("Wbl2TAMLlfwkX8QDwztB") ||
          this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")));
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style scoped>
</style>